import React, { useState } from 'react';
import PropTypes from 'prop-types';
import style from './style.css';

const HistoricalFilter = props => {
    const [value, setValue] = useState(props.field.value);

    const getLabel = months => {
        return `${months} MO`;
    };

    const onChange = (e, option) => {
        e.preventDefault();
        setValue(option);
        props.form.setFieldValue(props.field.name, option);
    };

    return (
        <ul className="pagination list-group list-group-horizontal" style={{ display: 'flex', margin: '0em' }}>
            {props.options.map(option => (
                <li className={value === option ? 'active list-group-item' : 'list-group-item'} key={option}>
                    <a href="#" onClick={e => onChange(e, option)} className={value === option && style.selectedOption}>
                        {getLabel(option)}
                    </a>
                </li>
            ))}
        </ul>
    );
};

HistoricalFilter.propTypes = {
    options: PropTypes.array,
    form: PropTypes.object,
    field: PropTypes.object,
};
export default HistoricalFilter;
